module.exports = __webpack_public_path__ + "images/choice_steak_29c2e20.png";